module.exports = __webpack_public_path__ + "img/14.aa284d6d.jpg";